const hasPermission = {
    install (Vue, options){
        Vue.directive('hasPermission', {
            bind(el, binding, vnode){
                let permissionList = sessionStorage.getItem('permission');
                if(permissionList && permissionList.length && !permissionList.includes(binding.value)){
                    // el.parentNode.removeChild(el);
                    el.style.display="none";
                }
            }
        })
    }
}

export default hasPermission



// WEBPACK FOOTER //
// ./src/hasPermission.js